export const defaultPageSize = 10;

export const firstPage = Object.freeze({
  pageSize: defaultPageSize,
  current: 1,
  total: 0,
});

export function getPaginationOrDefault({current, pageSize, total}, defaultPagination = firstPage) {
  return (current && pageSize && total && {current, pageSize, total}) || defaultPagination;
}


// WEBPACK FOOTER //
// ./src/utils/pagination.js